import Navbar from "../global/navbar";
import Portfolio from "../components/portfolio";
import Footer from "../global/footer";

export default function PortfolioPage() {
  return (
    <>
      <Navbar />
      <Portfolio />
      <Footer />
    </>
  );
}
